import {
  Heading,
  Text,
  Button,
  FiDownload,
  Box,
  Flex,
  Divider,
  FormProvider,
  TextField,
  useForm,
  FiSend,
  FiLogIn,
} from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';
import useSignupSummary from './hooks/useSignupSummary';
import { useNavigate } from 'react-router-dom';
import { paths } from '../../../routes/paths';

interface ItemListProps {
  items: string[];
}

const ItemList = (props: ItemListProps) => {
  const { items } = props;
  return (
    <Flex direction="column" gap={3}>
      {items.map((item, index) => (
        <Flex gap={2} alignItems="center" key={item}>
          <Flex
            width="18px"
            height="18px"
            borderRadius="full"
            justifyContent="center"
            alignItems="center"
            bg="#101828"
          >
            <Text color="white" size="xs" width="18px" textAlign="center">
              {index + 1}
            </Text>
          </Flex>
          <Box minWidth="min-content" color="content-secondary">
            {item}
          </Box>
        </Flex>
      ))}
    </Flex>
  );
};

export const SignupSummary = () => {
  const { t } = useTranslation();
  const {
    onSubmit,
    isPending: isLoadingMutate,
    url,
    isLoadingUrl,
  } = useSignupSummary();
  const navigate = useNavigate();

  const formMethods = useForm({ defaultValues: { email: '' } });
  const { handleSubmit } = formMethods;

  return (
    <Flex w="full" px="48px" direction="column" gap="40px">
      <Box>
        <Heading mb={3}>{t('businessSignup.summary.title')}</Heading>
        <Text variant="regular" size="md" color="content-secondary">
          {t('businessSignup.summary.subtitle')}
        </Text>
      </Box>
      <Flex gap={3} direction="column">
        <Text variant="medium" size="xl" mb={3}>
          {t('businessSignup.summary.listTitle')}
        </Text>
        <Box>
          <Divider />
        </Box>
        <ItemList
          items={[
            t('businessSignup.summary.firstListItem'),
            t('businessSignup.summary.secondListItem'),
            t('businessSignup.summary.thirdListItem'),
          ]}
        />
      </Flex>
      <Flex gap={6} direction={{ base: 'column', sm: 'row' }}>
        <Button
          variant="primary"
          leftIcon={<FiDownload />}
          isLoading={isLoadingUrl}
          onClick={() => !isLoadingUrl && window.open(url, '_blank')}
        >
          {isLoadingUrl ? 'Loading' : t('businessSignup.summary.downloadPDF')}
        </Button>
        <Button
          variant="secondary"
          leftIcon={<FiLogIn />}
          onClick={() => navigate(paths.home)}
        >
          {t('businessSignup.summary.signIn')}
        </Button>
      </Flex>
      <Flex direction="column" gap={3}>
        <Text variant="medium" size="xl" mb={3}>
          {t('businessSignup.summary.sendEmailOtherPerson')}
        </Text>
        <Box>
          <Divider />
        </Box>
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormProvider {...formMethods}>
            <Flex gap={2}>
              <TextField
                name="email"
                label={t('common.user.email')}
                placeholder={t('common.user.email')}
                type="email"
                size="md"
              />
              {/* TODO: Fix here */}
              <Flex justifyContent={'end'} alignItems={'end'}>
                <Button
                  type="submit"
                  isLoading={isLoadingMutate}
                  leftIcon={<FiSend />}
                >
                  {t('businessSignup.summary.send')}
                </Button>
              </Flex>
            </Flex>
          </FormProvider>
        </form>
      </Flex>
    </Flex>
  );
};

export default SignupSummary;
